import type { Duration } from "date-fns";

import { parseMonthYear } from "@/ui/molecules/MonthsBasedDatePicker";

export const addOneMonthToDurationAsStartDateIsFirstDayOfTheMonthAndEndDateIsLastDayOfTheMonth =
    (duration: Duration) => {
        const { months = 0, ...rest } = duration;
        return { months: months + 1, ...rest };
    };

export const addOneMonthToStringDateAsStartDateIsFirstDayOfTheMonthAndEndDateIsLastDayOfTheMonth =
    (date: string) => {
        const { month, year } = parseMonthYear(date);
        const newMonth = month === 12 ? 1 : month + 1;
        const newYear = month === 12 ? year + 1 : year;
        return `${newMonth.toString().padStart(2, "0")}/${newYear}`;
    };
